import React from "react";
import { useUserAnalytics } from "../hooks/useUserAnalytics";

const AnalyticsTracker: React.FC = React.memo(() => {
  useUserAnalytics();
  return null;
});

export default AnalyticsTracker;
